import { SecurePassStatus, SecurePassTagStatus } from "@/typedefs/securePass";
export var TrailerType;
(function (TrailerType) {
    TrailerType[TrailerType["Open"] = 1] = "Open";
    TrailerType[TrailerType["Enclosed"] = 2] = "Enclosed";
})(TrailerType || (TrailerType = {}));
export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus[ShipmentStatus["Draft"] = 1] = "Draft";
    ShipmentStatus[ShipmentStatus["Pending"] = 2] = "Pending";
    ShipmentStatus[ShipmentStatus["Completed"] = 3] = "Completed";
    ShipmentStatus[ShipmentStatus["Posted"] = 4] = "Posted";
    ShipmentStatus[ShipmentStatus["Assigned"] = 5] = "Assigned";
    ShipmentStatus[ShipmentStatus["Delivered"] = 6] = "Delivered";
    ShipmentStatus[ShipmentStatus["Incomplete"] = 7] = "Incomplete";
})(ShipmentStatus || (ShipmentStatus = {}));
export var DealerExchange;
(function (DealerExchange) {
    DealerExchange[DealerExchange["Ordered"] = 1] = "Ordered";
    DealerExchange[DealerExchange["Unordered"] = 2] = "Unordered";
})(DealerExchange || (DealerExchange = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType[IntegrationType["WWL"] = 1] = "WWL";
})(IntegrationType || (IntegrationType = {}));
export var ShipmentIncompleteStatus;
(function (ShipmentIncompleteStatus) {
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["NOT_APPLICABLE"] = 1] = "NOT_APPLICABLE";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["INCIDENT"] = 2] = "INCIDENT";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["MISINFORMATION"] = 3] = "MISINFORMATION";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["NOT_AVAILABLE"] = 4] = "NOT_AVAILABLE";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["CANCELLED"] = 5] = "CANCELLED";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["DRY_RUN"] = 6] = "DRY_RUN";
    ShipmentIncompleteStatus[ShipmentIncompleteStatus["EXCHANGE_SET_TO_INCOMPLETE"] = 7] = "EXCHANGE_SET_TO_INCOMPLETE";
})(ShipmentIncompleteStatus || (ShipmentIncompleteStatus = {}));
export var RUCARiskScore;
(function (RUCARiskScore) {
    RUCARiskScore[RUCARiskScore["LowRisk"] = 1] = "LowRisk";
    RUCARiskScore[RUCARiskScore["MediumRisk"] = 2] = "MediumRisk";
    RUCARiskScore[RUCARiskScore["HighRisk"] = 3] = "HighRisk";
    RUCARiskScore[RUCARiskScore["VeryHighRisk"] = 4] = "VeryHighRisk";
})(RUCARiskScore || (RUCARiskScore = {}));
export var HardRouteLocation;
(function (HardRouteLocation) {
    HardRouteLocation[HardRouteLocation["NormalRoute"] = 1] = "NormalRoute";
    HardRouteLocation[HardRouteLocation["DifficultPickup"] = 2] = "DifficultPickup";
    HardRouteLocation[HardRouteLocation["DifficultDropoff"] = 3] = "DifficultDropoff";
    HardRouteLocation[HardRouteLocation["Both"] = 4] = "Both";
})(HardRouteLocation || (HardRouteLocation = {}));
export var ShipmentLocked;
(function (ShipmentLocked) {
    ShipmentLocked[ShipmentLocked["OnHold"] = 1] = "OnHold";
    ShipmentLocked[ShipmentLocked["Pending"] = 2] = "Pending";
})(ShipmentLocked || (ShipmentLocked = {}));
export var ShipmentCancelReason;
(function (ShipmentCancelReason) {
    ShipmentCancelReason[ShipmentCancelReason["Price"] = 1] = "Price";
    ShipmentCancelReason[ShipmentCancelReason["NoLongerNeeded"] = 2] = "NoLongerNeeded";
    ShipmentCancelReason[ShipmentCancelReason["DealFellThrough"] = 3] = "DealFellThrough";
    ShipmentCancelReason[ShipmentCancelReason["VehicleMechanicalIssues"] = 4] = "VehicleMechanicalIssues";
    ShipmentCancelReason[ShipmentCancelReason["Other"] = 5] = "Other";
})(ShipmentCancelReason || (ShipmentCancelReason = {}));
export var AutosledCancelReason;
(function (AutosledCancelReason) {
    AutosledCancelReason[AutosledCancelReason["NoResponseFromTransporter"] = 1] = "NoResponseFromTransporter";
    AutosledCancelReason[AutosledCancelReason["ExchangeWasCanceled"] = 3] = "ExchangeWasCanceled";
    AutosledCancelReason[AutosledCancelReason["TooManyETAChanges"] = 4] = "TooManyETAChanges";
    AutosledCancelReason[AutosledCancelReason["ChangeOfRoute"] = 5] = "ChangeOfRoute";
    AutosledCancelReason[AutosledCancelReason["EquipmentMalfunction"] = 6] = "EquipmentMalfunction";
    AutosledCancelReason[AutosledCancelReason["TookTooLong"] = 7] = "TookTooLong";
    AutosledCancelReason[AutosledCancelReason["Other"] = 2] = "Other";
})(AutosledCancelReason || (AutosledCancelReason = {}));
export var TransporterCancelReason;
(function (TransporterCancelReason) {
    TransporterCancelReason[TransporterCancelReason["EquipmentMalfunction"] = 1] = "EquipmentMalfunction";
    TransporterCancelReason[TransporterCancelReason["ChangeOfRoute"] = 2] = "ChangeOfRoute";
    TransporterCancelReason[TransporterCancelReason["UnitNotReady"] = 3] = "UnitNotReady";
    TransporterCancelReason[TransporterCancelReason["UnitNotAsDescribed"] = 4] = "UnitNotAsDescribed";
    TransporterCancelReason[TransporterCancelReason["Reconsidered"] = 6] = "Reconsidered";
    TransporterCancelReason[TransporterCancelReason["RenegotiatingRate"] = 7] = "RenegotiatingRate";
    TransporterCancelReason[TransporterCancelReason["NoGatepass"] = 8] = "NoGatepass";
    TransporterCancelReason[TransporterCancelReason["NoPSI"] = 9] = "NoPSI";
    TransporterCancelReason[TransporterCancelReason["UnitDoesntFit"] = 10] = "UnitDoesntFit";
    TransporterCancelReason[TransporterCancelReason["CantMakeETA"] = 11] = "CantMakeETA";
    TransporterCancelReason[TransporterCancelReason["DriverSwitch"] = 12] = "DriverSwitch";
    TransporterCancelReason[TransporterCancelReason["PickupLocationIssue"] = 13] = "PickupLocationIssue";
    TransporterCancelReason[TransporterCancelReason["Other"] = 5] = "Other";
})(TransporterCancelReason || (TransporterCancelReason = {}));
export var ShipperCancelReason;
(function (ShipperCancelReason) {
    ShipperCancelReason[ShipperCancelReason["Price"] = 1] = "Price";
    ShipperCancelReason[ShipperCancelReason["NoLongerNeeded"] = 2] = "NoLongerNeeded";
    ShipperCancelReason[ShipperCancelReason["DealFellThrough"] = 3] = "DealFellThrough";
    ShipperCancelReason[ShipperCancelReason["VehicleMechanicalIssues"] = 4] = "VehicleMechanicalIssues";
    ShipperCancelReason[ShipperCancelReason["TookTooLong"] = 6] = "TookTooLong";
    ShipperCancelReason[ShipperCancelReason["Other"] = 5] = "Other";
})(ShipperCancelReason || (ShipperCancelReason = {}));
export var DispatchSource;
(function (DispatchSource) {
    DispatchSource[DispatchSource["AutosledDashboard"] = 1] = "AutosledDashboard";
    DispatchSource[DispatchSource["Email"] = 2] = "Email";
    DispatchSource[DispatchSource["CentralDispatch"] = 3] = "CentralDispatch";
    DispatchSource[DispatchSource["SuperDispatch"] = 4] = "SuperDispatch";
    DispatchSource[DispatchSource["Other"] = 5] = "Other";
})(DispatchSource || (DispatchSource = {}));
export var CreateShipmentStep;
(function (CreateShipmentStep) {
    CreateShipmentStep[CreateShipmentStep["ShipmentInfo"] = 0] = "ShipmentInfo";
    CreateShipmentStep[CreateShipmentStep["VehicleDetails"] = 1] = "VehicleDetails";
})(CreateShipmentStep || (CreateShipmentStep = {}));
